import { render } from "./EnrollmentChat.vue?vue&type=template&id=62d7555e&scoped=true"
import script from "./EnrollmentChat.vue?vue&type=script&lang=js"
export * from "./EnrollmentChat.vue?vue&type=script&lang=js"

import "./EnrollmentChat.vue?vue&type=style&index=0&id=62d7555e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62d7555e"

export default script